module.exports = __webpack_public_path__ + "img/case2.8babb41d.jpg";